import { getStoredTheme, saveTheme } from '../storage/themeStore.ts'
import { syncMatrixRain } from './matrixRain.ts'

/** Void Cobalt (default) + Matrix + Minimal White Platinum. */
export type ZionThemeId = 'default' | 'matrix' | 'white_platinum'

export interface ZionThemeMeta {
  id: ZionThemeId
  name: string
  description: string
  icon: string
  light: boolean
  recommended?: boolean
}

export const ZION_THEMES: ZionThemeMeta[] = [
  {
    id: 'default',
    name: 'Minimal Void & Cobalt',
    description: 'OLED puro. Cobalt elettrico e ciano.',
    icon: '◆',
    light: false,
    recommended: true,
  },
  {
    id: 'matrix',
    name: 'MATRIX',
    description: 'Nero assoluto. Verde hi-tech.',
    icon: '🟢',
    light: false,
  },
  {
    id: 'white_platinum',
    name: 'Minimal White Platinum',
    description: 'Bianco platino, bolle perla e cobalto.',
    icon: '◇',
    light: true,
  },
]

export function parseThemeId(raw?: string | null | undefined): ZionThemeId {
  const id = String(raw ?? '')
    .trim()
    .toLowerCase()
  if (id === 'matrix') return 'matrix'
  if (
    id === 'white_platinum' ||
    id === 'minimal_white_platinum' ||
    id === 'white-platinum' ||
    id === 'arctic_light' ||
    id === 'glacial_white'
  ) {
    return 'white_platinum'
  }
  // Legacy (cyber, phantom, …) → Void Cobalt
  return 'default'
}

export function applyTheme(theme: ZionThemeId): void {
  const id = parseThemeId(theme)
  document.documentElement.dataset.theme = id
  document.documentElement.style.colorScheme = id === 'white_platinum' ? 'light' : 'dark'
  saveTheme(id)
  syncMatrixRain(id)
}

export function initTheme(): void {
  applyTheme(getStoredTheme())
}

export function getCurrentTheme(): ZionThemeId {
  return parseThemeId(document.documentElement.dataset.theme ?? getStoredTheme())
}
